<div
  class="view-icon-wrapper"
  [ngClass]="{ 'expanded-icon': expanded }"
  (click)="action($event)"
>
  <img [src]="icon" [alt]="altText" />
</div>
